import React, {useEffect, useRef, useState} from 'react';

type DropdownMenuProps = {
    caret?: boolean;
};

// NOTE - this implementation leaves a lot to be desired. It requires that there be two distinct child nodes
//        based and assumes the first is the dropdown toggle and the second is the dropdown content.
export const DropdownMenu: React.FunctionComponent<DropdownMenuProps> = ({caret = false, ...props}) => {
    const dropdownContainerRef = useRef<HTMLDivElement>(null);
    const [isShowingDropdown, setIsShowingDropdown] = useState<boolean>(false);

    useEffect(() => {
        function handleClickOutside(event: MouseEvent) {
            // @ts-ignore
            if (dropdownContainerRef?.current && !dropdownContainerRef?.current?.contains(event.target)) {
                setIsShowingDropdown(false);
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [dropdownContainerRef]);

    const dropdownButtonClasses = [
        caret && 'dropdown-toggle',
        'text-dark'
    ]
        .filter(Boolean)
        .join(' ');

    return (
        <>
            {Array.isArray(props.children) && props?.children?.length > 1 &&
            <div className="dropdown"
                 ref={dropdownContainerRef}
            >
                <a href="#"
                   className={dropdownButtonClasses}
                   onClick={(e) => {
                       e.preventDefault();
                       e.stopPropagation();
                       setIsShowingDropdown(!isShowingDropdown);
                   }}
                >
                    {props.children[0]}
                </a>
                {isShowingDropdown && props.children[1]}
            </div>
            }
        </>
    )
}